/**
 * Tożsamość gościa (niezalogowanego gracza): stabilny userId w localStorage,
 * tworzony leniwie — ten sam klucz co reszta aplikacji ('userId').
 */
export function getOrCreateGuestUserId(user) {
  if (user?._id) return user._id;
  let userId = localStorage.getItem('userId');
  if (!userId) {
    userId = 'user_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('userId', userId);
  }
  return userId;
}

export function getDisplayName(user, fallback = 'Gracz') {
  return user?.username || localStorage.getItem('username') || fallback;
}
